import { render, staticRenderFns } from "./detailTypeWorkLeave.vue?vue&type=template&id=bdaaf596&scoped=true&"
import script from "./detailTypeWorkLeave.vue?vue&type=script&lang=js&"
export * from "./detailTypeWorkLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaaf596",
  null
  
)

export default component.exports